import { Box } from '@mui/material';
import { DataGridPremiumProps } from '@mui/x-data-grid-premium';
import IncDataGrid from 'components/inc-data-grid/inc-data-grid.component';
import useClientPaginationModel from './client-pagination-data-grid.hooks';
import { DataGridType } from 'components/inc-data-grid/inc-data-grid.utils';

type ClientPaginationDataGridProps = {
  rows: any;
  isLoading?: boolean;
  'data-testid'?: string;
  resizable?: boolean;
  dataGridType?: DataGridType;
} & Partial<DataGridPremiumProps>;

const ClientPaginationDataGrid = ({
  rows,
  isLoading,
  columns,
  'data-testid': dataTestId = 'ClientPaginationDataGrid',
  onRowClick,
  resizable = true,
  dataGridType,
  initialState = {},
  ...rest
}: ClientPaginationDataGridProps) => {
  const { clientPaginationModel, setClientPaginationModel } =
    useClientPaginationModel();

  return (
    <Box display="flex" data-testid={dataTestId} flexDirection="column">
      <IncDataGrid
        resizable={resizable}
        rows={rows ?? []}
        columns={columns}
        loading={isLoading}
        pagination
        paginationModel={clientPaginationModel}
        onPaginationModelChange={newPaginationModel =>
          setClientPaginationModel(newPaginationModel)
        }
        onRowClick={onRowClick}
        dataGridType={dataGridType}
        initialState={{
          ...initialState,
        }}
        {...rest}
      />
    </Box>
  );
};

export default ClientPaginationDataGrid;
